export default __webpack_public_path__ + "static/media/item-2-white.f6b73263.jpg";